import styled from 'styled-components'

import { media } from '../../../../../utils/style-utils'

export default styled.div`
  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  bottom: 0.5rem;

  ${media.md`
    display: none;
  `}
`
